import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'

import { isEqualWorkspace } from '../../../../workspace/helpers'
import { useRequiredWorkspaceOperationsContext } from '../../../../workspace/operationsContext'
import { useWorkspaceManagerContext } from '../../../../workspace/workspaceManagerContext'
import { useOpenWorkspace } from '../../../branchesPanel/branchDetails/branchWorkspaces/useOpenWorkspace'

export const OpenWorkspaceButton = () => {
  const translate = useTranslate()
  const { currentWorkspaceKey } = useWorkspaceManagerContext()
  const { workspaceKey } = useRequiredWorkspaceOperationsContext()
  const isWorkspaceOpen = isEqualWorkspace(workspaceKey, currentWorkspaceKey)
  const { mutateAsync, isLoading } = useOpenWorkspace(workspaceKey)

  return (
    <Button
      startIcon="ArrowRightEndOnRectangle"
      onClick={mutateAsync}
      isLoading={isLoading}
      disabled={isWorkspaceOpen}
    >
      {translate('workspaceDetailsPanel.button.openWorkspace')}
    </Button>
  )
}
